import { DatePicker, DatePickerProps } from '@distribusion/owl-frontend-ui'
import { FieldProps, useField } from 'formik'
import React, { ReactElement } from 'react'

import { useTranslation } from '@lib/i18n'

type DatePickerFieldProps = FieldProps<Date> & DatePickerProps

const DatePickerField = ({
  field,
  form: { setFieldValue },
  onChange,
  errorMessage: externalErrorMessage,
  ...rest
}: DatePickerFieldProps): ReactElement => {
  const { t } = useTranslation()

  const weekDays = t('calendar.days', { returnObjects: true, defaultValue: [] }) as string[]

  const [_, { touched, error }] = useField(field.name)
  const errorMessage = externalErrorMessage || (touched ? error : null)
  const handleChange = (value: Date): void => {
    setFieldValue(field.name, value)
    onChange?.(value)
  }

  return <DatePicker {...field} {...rest} weekDays={weekDays} errorMessage={errorMessage} onChange={handleChange} />
}

export default DatePickerField
